import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    step: '1', // 预授权步骤
    edit: true, // 预授权编辑与否
    claimStep: '1', // 理赔申请步骤
    claimEdit: true, // 理赔申请编辑与否
    nopay: 1, //保单管理
    memberNo: "", //添加银行卡时被保人会员id 
    claToBKcard: false,//origin:判断从理赔到bankcard
    claToOther: false,//从理赔到其他页，判断是否要初始带出默认保单信息（因为返回时不会有路径参数）
    claToPMan: false, //从理赔到保单管理，因为返回时要记住状态
    preToPMan: false,//同上
    appoint: false,//同上
    doctor: false, //同上
    othToBKcard: false,//origin:判断从其他页面到bankcard
    showPreUpload: false, //进入预授权申请时，是否展示上传组件
    showCliUpload: false, //进入理赔申请时，是否展示上传组件
    nextP: true, //是否展示上传的下一页按钮
    selectedDepList: sessionStorage.getItem('selectedDepList') ? JSON.parse(sessionStorage.getItem('selectedDepList')) : [], // 选中科室
    selectedDoctor: sessionStorage.getItem('selectedDoctor') ? JSON.parse(sessionStorage.getItem('selectedDoctor')) : {}, // 选中的医生
    selectedCard: {},
    goldDorDistrictListSave: [],
    // 保思
    withdrawDetailInfo: sessionStorage.getItem('withdrawDetailInfo') ? JSON.parse(sessionStorage.getItem('withdrawDetailInfo')) : {},
    // 系统主题色
    websiteColor: localStorage.getItem('websiteColor'),
  },
  mutations: {
    setPreUpload (state, str) {
      state.showPreUpload = str
    },
    setappoint (state, str) {
      state.appoint = str
    },
    setCliUpload (state, str) {
      state.showCliUpload = str
    },
    setClaToOther (state, str) {
      state.claToOther = str
    },
    setNextP (state, str) {
      state.nextP = str
    },
    setNopay (state, str) {
      state.nopay = str
    },
    setStep (state, str) {
      state.step = str
    },
    setMemberNo (state, str) {
      state.memberNo = str
    },
    setClaToBKcard (state, str) {
      state.claToBKcard = str
    },
    setOthToBKcard (state, str) {
      state.othToBKcard = str
    },
    setPreToPMan (state, str) {
      state.preToPMan = str
    },
    setClaToPMan (state, str) {
      state.claToPMan = str
    },
    setEdit (state, str) {
      state.edit = str
    },
    setClaimStep (state, str) {
      state.claimStep = str
    },
    setClaimEdit (state, str) {
      state.claimEdit = str
    },
    // 金牌医生预约开始
    setDoctor (state, str) {
      state.doctor = str
    },
    setSelectedDepList (state, str) {
      state.selectedDepList = str
    },
    setSelectedDoctor (state, str) {
      state.selectedDoctor = str
    },
    setSelectedCard(state, str) {
      state.selectedCard = str
    },
    setGoldDorDistrictListSave(state, str) {
      state.goldDorDistrictListSave = str
    },
    // 金牌医生预约结束
    // 保思
    setWithdrawDetailInfo(state, str) {
      state.withdrawDetailInfo = str;
    },
    // 系统主题色
    setWebsiteColor(state, str) {
      const theme = {
        '03daa2': 'green',
        '4889ff': 'blue',
        'ff7c6d': 'red',
        'ffad35': 'orange'
      }
      state.websiteColor = str;
      document.documentElement.setAttribute("theme", theme[str] || 'red');
    },
  },
  actions: {}
})
